import client from "@client";

import { formatOriginUrl } from "@utils/formatters";

export const env = import.meta.env;

/**
 * Bundler flags
 */
export const isProduction = env.PROD;
export const isDevelopment = env.DEV;
export const envMode = env.MODE;

/**
 * Client identifier
 */
export const clientId = env.VITE_CLIENT_ID;

/**
 * Application version set in the package.json
 */
export const appVersion = env.VITE_APP_VERSION;

/**
 * Backend api url
 */
export const apiUrlOriginacaoDefault = env.VITE_API_URL_ORIGINACAO;
export const apiUrlOriginacaoV2 = env.VITE_API_URL_ORIGINACAO_V2;
export const apiUrlReapresentacaoTed = env.VITE_API_URL_REAPRESENTACAO_TED;
export const apiUrlSeguros = env.VITE_API_URL_SEGUROS;

function getApiUrlOriginacao() {
  const urlParams = new URLSearchParams(window.location.search);
  const apiUrlParam = urlParams.get("apiUrl");

  if (env.MODE === "production") return apiUrlOriginacaoDefault;

  if (apiUrlParam === "v2") {
    localStorage.setItem("apiUrlOriginacao", "v2");
    return apiUrlOriginacaoV2;
  } else if (apiUrlParam === "v1") {
    localStorage.removeItem("apiUrlOriginacao");
    return apiUrlOriginacaoDefault;
  }

  const storedApiUrl = localStorage.getItem("apiUrlOriginacao");

  if (storedApiUrl === "v2") {
    return apiUrlOriginacaoV2;
  } else {
    return apiUrlOriginacaoDefault;
  }
}

export const apiUrlOriginacao = getApiUrlOriginacao();
export const isHomologEnvironemnt = new RegExp(/(-dev)|(-staging)/gi).test(
  formatOriginUrl(apiUrlOriginacao).toLocaleUpperCase(),
);

/**
 * AWS api url
 */
export const apiUrlBff = env.VITE_API_URL_BFF;

/**
 * Backend websocket url
 */
export const apiUrlOriginacaoWs = env.VITE_API_URL_ORIGINACAO_WS;

/**
 * AWS api url
 */
export const apiUrlPrivateCredit = env.VITE_API_URL_PRIVATE_CREDIT;

/**
 * AWS api url
 */
export const urlRedirectPublicCredit = env.VITE_REDIRECT_PUBLIC_CREDIT;
export const urlRedirectCommissioningPortal =
  env.VITE_REDIRECT_COMMISSIONING_PORTAL;

/**
 * New Relic settings
 */
export const newRelic = {
  applicationId: env.VITE_NEW_RELIC_APPLICATION_ID,
  licenceKey: env.VITE_NEW_RELIC_LICENSE_KEY,
  accountId: env.VITE_NEW_RELIC_ACCOUNT_ID,
} as const;

/**
 * Smartlook client key
 */
export const smartlookClientKey = env.VITE_SMARTLOOK_CLIENT_KEY;

/**
 * Clarity client key
 */
export const clarityClientKey = env.VITE_CLARITY_CLIENT_KEY;

/**
 * Main URL
 */
export const mainUrl = formatOriginUrl(env.VITE_MAIN_URL);

/**
 * Card exclusive URL
 */
export const cardExclusiveUrl = formatOriginUrl(env.VITE_CARD_EXCLUSIVE_URL);

/**
 * Enable API mocks
 */
export const enableApiMocks = env.VITE_ENABLE_API_MOCKS === "1";

/**
 * Static Client Settings with apiKeys object set from environment variables
 */
export const clientSettings: ClientSettingsWithKeys = {
  ...client,
  apiKeys: {
    newRelic: newRelic,
    smartlook: {
      clientKey: smartlookClientKey,
    },
    clarity: {
      clientKey: clarityClientKey,
    },
  },
};
